module.exports = __webpack_public_path__ + "img/TruroTaxBill.2897de9c.png";